var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('a',{class:_vm.generateClass,attrs:{"href":_vm.generateLink,"target":"_blank"},on:{"click":function($event){return _vm.checkClick()}}},[_c('font-awesome-icon',{staticClass:"fa-lg",attrs:{"icon":_vm.generateIcon}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }